import { LicensePlateType } from "@omni/types/api/product/bff/shared/enums/licensePlateType.enum";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { BonusCardType } from "@omni/types/enums/bonusCardType.enum";
import { BaseStoreAware } from "@omni/types/utils/baseStoreAware";

type Patterns = BaseStoreAware<{
    phone: RegExp;
    promotionCode: RegExp;
    email: RegExp;
    bonusCard: Record<BonusCardType | "anyBonusCard", RegExp | null>;
    giftCard: RegExp;
    licensePlate: Record<LicensePlateType, RegExp>;
}>;

export const Patterns: Patterns = {
    [BaseStore.Hubo]: {
        phone: /^\d{8,15}$/i,
        giftCard: /^\d+(-?)\d*$/,
        promotionCode: /^[a-zA-Z0-9-()]+$/,
        email: /^(?:[a-z0-9!$'*+=_`~-]+(?:\.[a-z0-9!$'*+=_`~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+)$/i,
        bonusCard: {
            [BonusCardType.Physical]: /^20620(\d{8})$/,
            [BonusCardType.Electronic]: /^2499(\d{9})$/,
            anyBonusCard: /^(20620\d{8}|2499\d{9})$/
        },
        licensePlate: {
            [LicensePlateType.Standard]: /^[0-9A-Z]{1}-[A-Z]{3}-[0-9]{3}$/,
            [LicensePlateType.Personalized]: /^[A-Z0-9-]{1,8}$/
        }
    },
    [BaseStore.Etna]: {
        phone: /^\d{8,15}$/i,
        giftCard: /^\d+(-?)\d*$/,
        promotionCode: /^[a-zA-Z0-9-()]+$/,
        email: /^(?:[a-z0-9!$'*+=_`~-]+(?:\.[a-z0-9!$'*+=_`~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+)$/i,
        bonusCard: {
            [BonusCardType.Physical]: /^20629(\d{8})$/,
            [BonusCardType.Electronic]: /^2498(\d{9})$/,
            anyBonusCard: /^(20629\d{8}|2498\d{9})$/
        },
        licensePlate: {
            [LicensePlateType.Standard]: /^[0-9A-Z]{1}-[A-Z]{3}-[0-9]{3}$/,
            [LicensePlateType.Personalized]: /^[A-Z0-9-]{1,8}$/
        }
    }
};
